/*****
 * Profile actions
 */
import {
    CURRENT_USER_PROFILE_LOADED,
    CURRENT_USER_SUMMARIES_LOADED,
    CURRENT_USER_CATEGORY_SUMMARY_LOADED,
} from './types';

import BaseAPI from '../../../src/utils/api/base_api';

import { isEmpty } from 'lodash';
import { loadQuestionnaireList } from '../vendor/actions';

export const loadCurrentUserProfile = (payload) => {
    return { type: CURRENT_USER_PROFILE_LOADED, payload };
};

// Used for loading the summaries for all questionnaires owned by a user
export const loadCurrentUserSummaries = (payload) => {
    return { type: CURRENT_USER_SUMMARIES_LOADED, payload };
};

export const loadCurrentUserCategorySummary = (payload) => {
    return { type: CURRENT_USER_CATEGORY_SUMMARY_LOADED, payload };
};

export const getCurrentUserProfile = () => (dispatch) => {
    BaseAPI.get('/company/profile')
        .then((response) => dispatch(loadCurrentUserProfile(response.data)))
        .catch((error) => console.error(error));
};

export const getCurrentUserSummaries = () => async (dispatch, getState) => {
    const state = getState();

    // Current user's profile
    const profile = await BaseAPI.get('/company/profile')
        .then((response) => dispatch(loadCurrentUserProfile(response.data)))
        .catch((error) => console.error(error));

    // Current user id
    const { id } = profile.payload;

    // Get our questionnaire list
    let { _questionnaireList } = state.vendorReducer;
    if (isEmpty(_questionnaireList[0])) {
        _questionnaireList = await BaseAPI.get('/qns')
            .then((response) => {
                dispatch(loadQuestionnaireList(response.data));
                return response.data;
            })
            .catch((error) => console.error(error));
    }

    // First questionnaire
    const defaultQuestionnaire = _questionnaireList[0].id;
    const statusReportId = _questionnaireList.filter(
        (questionniare) => questionniare.name === 'GDPR Status Report'
    )[0].id;

    // Use this ID to get a summary of all of the different questionnaires that are currently assigned to this vendor
    BaseAPI.get('/ans/summary', {
        params: { vendor_company_id: id },
    })
        .then((response) => dispatch(loadCurrentUserSummaries(response.data)))
        .catch((error) => console.error(error));

    // Get the category summary for the first of those questionnaires
    BaseAPI.get('/ans/categorySummary', {
        params: {
            questionnaire_id: statusReportId
                ? statusReportId
                : defaultQuestionnaire,
        },
    })
        .then((response) => {
            dispatch(loadCurrentUserCategorySummary(response.data));
        })
        .catch((error) => console.error(error));
};

export const getCurrentUserCategorySummary = (questionnaireId) => async (
    dispatch
) => {
    BaseAPI.get('/ans/categorySummary', {
        params: {
            questionnaire_id: questionnaireId,
        },
    })
        .then((response) => {
            dispatch(loadCurrentUserCategorySummary(response.data));
        })
        .catch((error) => console.error(error));
};



// WEBPACK FOOTER //
// ./src/redux/profile/actions.js